<template>
  <div class="table-container">
    <vab-query-form>
      <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
        <el-form-item label="">
          <el-select v-model="queryForm.is_supplement" clearable placeholder="商品类型" @keyup.enter.native="handleQuery"
            style="width: 150px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-cascader v-model="queryForm.cid" :props="queryProps" :options="typeList" clearable placeholder="商品分类"
            style="width: 200px;" @change="handleQuery"></el-cascader>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="queryForm.name" :clearable="true" placeholder="商品名称" />
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="queryForm.barcode" placeholder="商品条形码" clearable style="width: 250px" />
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="queryForm.record" placeholder="DW备案码" clearable style="width: 250px" />
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="queryForm.status" clearable placeholder="上架状态" @change="handleQuery"
            style="width: 150px;">
            <el-option v-for="item in shelfStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="batchPutOnShelf">
            批量上架
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="batchTakeOffShelf">
            批量下架
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="batchSetCategory">
            批量设置分类
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-plus" type="primary" @click="handleAdd">
            添加
          </el-button>
        </el-form-item>

        <el-form-item style="float: right">
          <div style="display: flex;">
            <el-input v-model="exchange_rate" style="width: 150px; margin-right: 8px;" :clearable="true"
              placeholder="请输入汇率" />
            <el-button type="primary" @click="save_exchange_rate">
              保存汇率
            </el-button>
          </div>
        </el-form-item>

      </el-form>
    </vab-query-form>

    <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
      :height="height" border @selection-change="setSelectRows" @sort-change="tableSortChange">
      <el-table-column show-overflow-tooltip type="selection" width="55" align="center"></el-table-column>
      <!-- 商品类型 -->
      <el-table-column show-overflow-tooltip prop="type" label="商品类型" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.is_supplement == 0">普通商品</div>
          <div v-if="row.is_supplement == 1">补价商品</div>
        </template>
      </el-table-column>
      <!-- 商品分类 -->
      <el-table-column prop="c_name" label="商品分类" align="center" />
      <!-- 商品名称 -->
      <el-table-column show-overflow-tooltip prop="name" width="300" label="商品名称" align="center"></el-table-column>
      <!-- 商品名称 -->
      <el-table-column show-overflow-tooltip prop="price" label="价格(韩元)" align="center"></el-table-column>
      <!-- 商品图片 -->
      <el-table-column show-overflow-tooltip label="商品图片" align="center">
        <template slot-scope="{ row }">
          <el-image v-if="imgShow" :src="row.pic" style="width: 60px; height: 60px; cursor: pointer;"
            @click="see_pic_info(row)"></el-image>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="分享图片" align="center">
        <template #default="{ row }">
          <el-image v-if="row.mini_code" :src="row.mini_code" @click="see_code_info(row)"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="上架状态" align="center">
        <template slot-scope="{ row }">
          <el-switch v-model="row.status" style="display: block" :inactive-value="1" :active-value="0"
            @change="handleSwitchChange(row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="置顶" align="center">
        <template slot-scope="{ row }">
          <el-switch v-model="row.top" style="display: block" :inactive-value="0" :active-value="1"
            @change="handleSwitchChange(row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="限时热卖" align="center">
        <template slot-scope="{ row }">
          <el-switch v-model="row.recommend" style="display: block" :inactive-value="0" :active-value="1"
            @change="handleSwitchChange(row)"></el-switch>
          <!-- {{ row.recommend ? '推荐' : '不推荐' }} -->
        </template>
      </el-table-column>


      <el-table-column label="顺手买推荐" align="center">
        <template slot-scope="{ row }">
          <el-switch v-model="row.is_conveniently" style="display: block" :inactive-value="0" :active-value="1"
            @change="handleSwitchChange(row)"></el-switch>
          <!-- {{ row.recommend ? '推荐' : '不推荐' }} -->
        </template>
      </el-table-column>


      <el-table-column show-overflow-tooltip label="创建时间" prop="update_time" width="180" align="center"
        sortable></el-table-column>
      <el-table-column show-overflow-tooltip label="操作面板" width="200px" align="center" fixed="right">
        <template #default="{ row }">
          <el-button type="text" style="margin-right: 20px;" @click="oneClickModify(row)">一键修改</el-button>
          <el-button type="text" style="margin-right: 20px;" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" style="color: #ff0000" @click="handleDelete(row)">删除</el-button>
          <!-- 
          <el-popconfirm title="确认删除该商品？" @confirm="handleDelete(row)">
            <el-button slot="reference" type="text" style="color: #ff0000">
              删除
            </el-button>
          </el-popconfirm> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
      :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit" :total="total" @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <el-dialog title="商品图片" :visible.sync="pic_img_show">
      <div style="display: flex; justify-content: center">
        <img :src="pic_img" alt="" style="max-width: 100%; max-height: 70vh; object-fit: contain;" />
      </div>
    </el-dialog>


    <el-dialog title="商品分类" :visible.sync="typeSet">
      <div style="display: flex; justify-content: center">
        <el-cascader v-model="form.cid" :props="props" :options="typeList" style="width: 100%"
          @change="getGoodsType"></el-cascader>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="typeSet = false">取 消</el-button>
        <el-button type="primary" @click="setTypeConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="分享图片" :visible.sync="code_img_show">
      <div style="display: flex; justify-content: center">
        <img :src="code_img" alt="" />
      </div>
    </el-dialog>
    <manage-goods ref="edit" @fetch-data="getnewlist"></manage-goods>
    <oneClickModify ref="modify" @fetch-data="getnewlist"></oneClickModify>
  </div>
</template>

<script>
import {
  goodsList,
  goodsDel,
  goods_status,
  GoodsCate_list,
  Index_country_list,
  GoodsExchangeRate_list,
  GoodsExchangeRate_update,
  cate_goods_edit
} from '@/api/xgcApi'
import manageGoods from '../components/productOnShelfComponent.vue'
import oneClickModify from '../components/oneClickModify.vue'

export default {
  name: 'ComprehensiveTable',
  components: {
    manageGoods,
    oneClickModify
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      props: {
        value: 'id',
        label: 'name',
        children: 'sub'
      },
      // 查询用的级联配置
      queryProps: {
        value: 'id',
        label: 'name',
        children: 'sub',
        emitPath: false,     // 只返回最后一级 id（选二级就是二级 id）
        checkStrictly: true  // 允许只选一级（只选一级就传一级 id）
      },
      countryList: [],
      pic_img: '',
      pic_img_show: false,
      code_img: '',
      code_img_show: false,
      typeSet: false,
      form: {},
      imgShow: true,
      list: [],
      typeList: [],
      imageList: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      background: true,
      selectRows: [],
      elementLoadingText: '正在加载...',
      queryForm: {
        page: 1,
        limit: 20,
        name: '',
        is_supplement: '0',
        kor_type: 0,
        cid: null,
        record: '',
        barcode: '',
        status: ''

      },
      options: [
        {
          value: '0',
          label: '普通商品',
        },
        {
          value: '1',
          label: '补价商品',
        }
      ],
      height: '72vh',
      exchange_rate: '',
      shelfStatus: [
        {
          value: '0',
          label: '上架',
        },
        {
          value: '1',
          label: '未上架',
        }
      ],

    }
  },
  computed: {
    // height() {
    //   console.log( this.$baseTableHeight())
    //   var height =this.$baseTableHeight()+100
    //   console.log( height)
    //   return height
    // },
  },
  created() {
    this.fetchData()
    this.getTypelist()
    this.getCountryList()
    this.getRate()
  },

  beforeDestroy() { },
  mounted() { },
  methods: {
    getGoodsType(e) {
      if (!e || e.length === 0) {
        this.form.cate_id = ''
        this.target = undefined
        return
      }
      // 保留 v-model 为数组，用于级联选择器正常回显
      this.form.cate_id = e[e.length - 1]   // 叶子节点 id
      const first = this.typeList.find(item => item.id === e[0])
      this.target = first ? first.is_cart : undefined
      console.log(this.form.cate_id, this.target)
    },
    // 批量上架
    batchPutOnShelf(type) {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        this.$baseConfirm('确定进行批量上架操作？', null, async () => {
          const {
            msg
          } = await goods_status({
            id: ids,
            status: 0
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },

    // 批量下架
    batchTakeOffShelf(type) {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        this.$baseConfirm('确定进行批量下架操作？', null, async () => {
          const {
            msg
          } = await goods_status({
            id: ids,
            status: 1
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 批量设置分类
    batchSetCategory() {
      if (this.selectRows.length > 0) {
        this.form.cid = []          // 清空级联选择器
        this.form.cate_id = ''
        this.target = undefined
        this.typeSet = true
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 批量设置分类
    setTypeConfirm() {
      if (!this.form.cate_id) {
        this.$baseMessage('请选择商品分类', 'warning')
        return
      }
      const ids = this.selectRows.map((item) => item.id).join()
      this.$baseConfirm('确定进行批量设置分类操作？', null, async () => {
        const { msg } = await cate_goods_edit({
          goods_id: ids,
          cate_id: this.form.cate_id   // 用叶子节点 id
        })
        this.typeSet = false
        this.$baseMessage(msg, 'success')
        this.fetchData()
      })
    },
    getRate() {
      GoodsExchangeRate_list({ kor_type: 0 }).then(res => {
        this.rateList = res.data[0]
        this.exchange_rate = res.data[0].value
      })
    },
    save_exchange_rate() {
      var data = {
        id: this.rateList.id, //id
        value: this.exchange_rate,//值
      }
      GoodsExchangeRate_update(data).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.fetchData()
      })
    },
    getCountryList() {
      // 获取线路
      // Index_country_list
      var data = {}
      Index_country_list(data).then(res => {
        this.countryList = res.data
      })
    },
    getTypelist() {
      var data = {
        page: 1,
      }
      this.listLoading = true
      GoodsCate_list(data)
        .then((res) => {
          this.typeList = res.data
        })
        .catch((err) => {
          this.listLoading = false
        })
    },
    see_pic_info(row) {
      this.pic_img = row.pic
      this.pic_img_show = true
    },
    see_code_info(row) {
      this.code_img = row.mini_code
      this.code_img_show = true
    },
    deleteGoods(row) {
      // 删除商品
    },
    //修改状态
    async handleSwitchChange(row) {
      this.form.id = row.id
      this.form.status = row.status
      this.form.top = row.top
      this.form.recommend = row.recommend
      this.form.is_conveniently = row.is_conveniently
      this.listLoading = true
      goods_status(this.form)
        .then((res) => {
          this.listLoading = false
          this.$message({
            type: 'success',
            message: '操作成功',
          })
        })
        .catch(() => {
          this.fetchData()
          this.listLoading = false
        })
      // const { msg } = await goodsDel(this.form)
      // this.$baseMessage(msg, 'success')
    },
    getnewlist() {
      this.fetchData()
    },
    tableSortChange() {
      const imageList = []
      this.$refs.tableSort.tableData.forEach((item, index) => {
        imageList.push(item.img)
      })
      this.imageList = imageList
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleAdd() {
      this.$refs['edit'].showEdit()
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    // 一键改价
    oneClickModify(row) {
      this.$refs['modify'].showEdit(row)
    },
    handleDelete(row) {
      this.$baseConfirm('你确定要删除当前项吗', null, async () => {
        const {
          msg
        } = await goodsDel({
          id: row.id
        })
        this.$baseMessage(msg, 'success')
        this.fetchData()
      })
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    handleQuery() {
      if (this.queryForm.cid === null || this.queryForm.cid === undefined) {
        this.queryForm.cid = ''
      }
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const {
        data
      } = await goodsList(this.queryForm)
      this.list = data.list
      this.total = data.count
      const imageList = []
      data.list.forEach((item, index) => {
        this.list[index].pic = item.pic.split(',')[0]
        imageList.push(item.pic)
      })
      this.imageList = imageList
      setTimeout(() => {
        this.listLoading = false
      }, 500)
    },
  },
}
</script>

<style scoped>
:deep .right-panel {
  display: flex;
  align-items: center;
}

.el-switch {
  height: auto !important;
}
</style>